import { useEffect, memo } from 'react';
import { fetchNotifications } from 'services/misc/miscAsync';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import {
  getCriticalNotifications,
  getCriticalNotificationsLoadingStatus,
  setCriticalNotificationsData,
} from 'services/misc/criticalNotificationSlice';
import Alert from 'components/Alert';
import LazySvg from 'components/LazySvg';
import If from 'components/If';
import { logErrors } from 'utils';

// styles
import styles from './index.module.scss';

// type
export type CriticalNotificationType = {
  id: string;
  message: string;
  notification: any;
};

function CriticalNotification() {
  const dispatch = useAppDispatch();
  const notifications = useAppSelector(getCriticalNotifications);
  const isNotificationsLoaded = useAppSelector(
    getCriticalNotificationsLoadingStatus,
  );

  // fetch critical notifications
  useEffect(() => {
    async function getNotifications() {
      try {
        await dispatch(fetchNotifications());
      } catch (error) {
        logErrors(error);
      }
    }

    if (!isNotificationsLoaded) {
      getNotifications();
    }
  }, []);

  const handleNotificationClose = (id: string) => {
    const updatedNotifications = notifications.filter((item) => item.id !== id);
    dispatch(setCriticalNotificationsData(updatedNotifications));
  };

  return (
    <If condition={!!notifications.length}>
      <div className={styles.container}>
        {notifications.map((item: CriticalNotificationType) => (
          <Alert
            key={item?.id}
            type='error'
            message={item?.message}
            closable={{
              'aria-label': 'close',
              closeIcon: (
                <LazySvg
                  name='close'
                  className={styles.closeIcon}
                  onClick={() => handleNotificationClose(item?.id)}
                />
              ),
            }}
            className={styles.notification}
          />
        ))}
      </div>
    </If>
  );
}

export default memo(CriticalNotification);
